<template>
  <div class="bmi-box">
    <span class="title">吸烟危害自测</span>
    <a-form :form="form" @reset="handleReset" @submit="handleSubmit">
      <a-form-item label="开始吸烟日期" :label-col="{span: 5}" :wrapper-col="{span: 8}">
        <a-date-picker
            @change="(date)=>startMoment=date"
            :disabled-date="disabledStartDate"
            v-decorator="['startDay',{rules:[{required: true, message: '请选择您的开始吸烟日期!'}]}]" />
      </a-form-item>
      <a-form-item label="最后吸烟日期" :label-col="{span: 5}" :wrapper-col="{span: 8}">
        <a-date-picker
            @change="(date)=>endMoment=date"
            :disabled-date="disabledEndDate"
            v-decorator="['endDay',{rules:[{required: true, message: '请选择您的最后吸烟日期!'}]}]" />
      </a-form-item>
      <a-form-item label="每天平均吸烟数（根）：" :label-col="{span: 5}" :wrapper-col="{span: 4}">
        <a-input
            type="number"
            v-decorator="['count',{rules:[{required: true, message: '请输入每天平均吸烟数！'}]}]" />
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 4 }">
        <a-button type="primary" html-type="submit">
          查看结果
        </a-button>
        <a-button html-type="reset" @click="handleReset" style="margin-left: 20px">
          我要重做
        </a-button>
      </a-form-item>
    </a-form>
    <div class="result-box" v-if="result.smokeYear > 0||result.smokeDay > 0">
      <span class="result-text">测试结果</span>
      <div class="smoke-time">您的烟龄为：
        <span v-if="result.smokeYear > 0"><span class="num">{{ result.smokeYear }}</span> 年 </span>
        <span v-if="result.smokeDay > 0"><span class="num">{{ result.smokeDay }}</span> 天 </span>
      </div>
      <div class="smoke-harm">吸烟对您的危害：减少
        <span v-if="result.reduceDay > 0"><span class="num">{{ result.reduceDay }}</span> 天 </span>
        <span v-if="result.reduceHour > 0"><span class="num">{{ result.reduceHour }}</span> 小时 </span>
        <span v-if="result.reduceHour === 0"><span class="num">30</span> 分 </span>
        的寿命
      </div>
      <div class="tip">本测试仅供参考，有关疾病相关诊断请咨询医生！</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      form: this.$form.createForm(this, {}),
      startMoment: '',
      endMoment: '',
      result: {
        smokeYear: 0,
        smokeDay: 0,
        reduceDay: 0,
        reduceHour: 0
      }
    };
  },

  methods: {
    /**
     * 判断开始日期是否可选
     * @param startMoment
     * @returns {boolean}
     */
    disabledStartDate(startMoment) {
      if (startMoment && startMoment.isAfter(moment())) {
        return true;
      }

      const endMoment = this.endMoment;
      if (!startMoment || !endMoment) {
        return false;
      }
      return startMoment.valueOf() > endMoment.valueOf();
    },

    /**
     * 判断结束日期是否可选
     * @param endMoment
     * @returns {boolean}
     */
    disabledEndDate(endMoment) {
      if (endMoment && endMoment.isAfter(moment())) {
        return true;
      }

      const startMoment = this.startMoment;
      if (!endMoment || !startMoment) {
        return false;
      }
      return startMoment.valueOf() >= endMoment.valueOf();
    },

    /** 提交查看结果 */
    handleSubmit() {
      this.form.validateFields((error, values) => {
        if (error === null) {
          let diffDays = this.endMoment.diff(this.startMoment, "days");
          if (diffDays === 0) {
            diffDays = 1;
          }
          if (diffDays >= 365) {
            this.result.smokeYear = parseInt(diffDays / 365);
            this.result.smokeDay = diffDays % 365;
          } else {
            this.result.smokeDay = diffDays;
          }

          let reduceHour = Math.round(diffDays * values['count'] * 10 / 60);
          if (reduceHour >= 24) {
            this.result.reduceDay = parseInt(reduceHour / 24);
            this.result.reduceHour = reduceHour % 24;
          } else {
            this.result.reduceHour = reduceHour;
          }
        }
      })
    },

    /** 重置查询 */
    handleReset() {
      this.form.resetFields();
      this.startMoment = undefined;
      this.endMoment = undefined;
      this.result.smokeYear = 0;
      this.result.smokeDay = 0;
    }
  },
};
</script>

<style lang="less" scoped>
.bmi-box {
  padding-left: 15px;

  .title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 20px;
    display: inline-block;
  }

  .result-box {
    margin-top: 20px;

    .result-text {
      font-size: 16px;
      font-weight: bold;
    }

    .smoke-time, .smoke-harm {
      margin: 10px;
    }

    .num {
      color: #ff0c0c;
      font-weight: bold;
    }

    .tip {
      margin: 10px;
      color: #999;
      font-size: 14px;
    }
  }
}
</style>